import React from 'react'
import DatePicker from './DatePicker/DatePicker'
import { DEF_DATE_TIME, DEF_TIME } from '../../utility/time'
import { TIMEZONE } from './DatePicker/dateUtility'
import moment from 'moment-timezone'
import TimePicker from './DatePicker/TimePicker'
import { checkIfOnlyDigits } from '../../utility'
import DateTimeRange from './DateTimeRange/DateTimeRange'

export const Input = ({ onValueChange, config, config: { useRange } = {}, ...props }) => {
  const onChange = (v, isLiteralValue) => {
    let val = null
    if (v) {
      if (typeof v === 'object' && typeof v.getTime === 'function') {
        v = moment(v)
      }
      val = typeof v === 'string' || typeof v === 'number'? v : typeof v === 'object' ? v.unix() * 1000 : null
      if (!isLiteralValue) {
        val = val && new Date(val).toISOString();
      }
    }
    onValueChange?.(val)
  }
  const val = props.data || props.value
  if (props.type && props.type.toLowerCase() === 'time') return <TimePicker {...props} config={config} value={val} onChange={onChange} />
  return useRange
    ? <DateTimeRange  {...props} config={config} value={val} onChange={onChange} />
    : <DatePicker {...props} config={config} value={val} onChange={onChange} isTime />
}

export const Output = props => {
  let data = props.data || props.value
  if (checkIfOnlyDigits(data)) data = parseInt(data, 10)
  let format = props.dateFormat || DEF_DATE_TIME
  if (props.type && props.type === 'TIME' && !props.dateFormat) {
    format = DEF_TIME
  }
  return <span>{data ? moment.utc(data).tz(TIMEZONE).format(format) : ''}</span>
}
